import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "manualAddress", "onCancel"];
import React from 'react';
import { Button, Message } from 'semantic-ui-react';
import { ADDRESS_NOT_FOUND_TEXT, ADDRESS_NOT_FOUND_HELP_TEXT } from './NoAddressSuggestionsDisplay.constants';
import Modal from '../../../../../foundation/components/Modal';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import AddressEnteredDisplay from '../AddressEnteredDisplay';
function NoAddressSuggestionsDisplay(_ref) {
  var open = _ref.open,
    manualAddress = _ref.manualAddress,
    onCancel = _ref.onCancel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getModalProps = _useSemanticUiProps.getModalProps;
  return /*#__PURE__*/React.createElement(Modal, _extends({
    open: open
  }, getModalProps(rest)), /*#__PURE__*/React.createElement(Modal.Header, null, "We couldn't find a formatted address"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("p", null, ADDRESS_NOT_FOUND_TEXT), /*#__PURE__*/React.createElement(AddressEnteredDisplay, {
    address: manualAddress
  }), /*#__PURE__*/React.createElement(Message, null, ADDRESS_NOT_FOUND_HELP_TEXT)), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel
  }, "Got it")));
}
export default NoAddressSuggestionsDisplay;